// SP時の処理(アコーディオン)
function recruitAppliSp() {
  // タイトルをクリックすると
  $(".js-application-titleBtn").off("click").on("click", function () {
    // クリックした次の要素を開閉
    $(this).next().slideToggle(300);
    // タイトルにopenクラスを付け外しして矢印の向きを変更
    $(this).toggleClass("ja-accordion-open");
  });
}

// PC時の処理(タブ)
function recruitAppliPc() {
  // PC時の処理をここに記述
	$(".js-application-titleBtn").off("click").on("click", function () {
    // クリックした次の要素を開閉
    var $contents = $(this).next().find('.js-application-main');
    // タイトルにopenクラスを付け外しして矢印の向きを変更
    $(".js-application-titleBtn").removeClass('js-tab-open')
    $(this).toggleClass("js-tab-open");
		$('.l-application-container__main-pc').children('.js-application-main').remove();
		$('.l-application-container__main-pc').append($contents.clone());
  });
}

// ウィンドウの初回読み込み時に実行
$(document).ready(function() {
  var winW = $(window).width();
  var devW = 767;

  if (winW <= devW) {
    // 767px以下の時の処理
    recruitAppliSp();
  } else {
    // 768pxより大きい時の処理
    recruitAppliPc();
  }
  
  // ウィンドウのリサイズイベントに対する処理
  $(window).on('resize', function(){
    var winW = $(window).width();
    var devW = 767;
    if (winW <= devW) {
      // 767px以下の時の処理
      recruitAppliSp();
    } else {
      // 768pxより大きい時の処理
      recruitAppliPc();
    }
  });
});